import debounce from 'lodash/debounce';
import { setMaxHeightStyle } from '../../../scripts/utils/setMaxHeightStyle';

export const initCollapsibleDimmerSwitchTechSpecsMenu = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-product-dimmer-switch-tech-specs-item-content]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};
